import {
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  toString1pkumu07cwy4m as toString,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  isInterface3d6p8outrmvmk as isInterface,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  hashCodeq5arwsb9dgti as hashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  KtMap140uvy3s5zad8 as KtMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  firstOrNull1gk7vzkf4h3nq as firstOrNull,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  isArray1hxjqtqy632bc as isArray,
  KtList3hktaavzmj137 as KtList,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$_0,
  HashSet_init_$Create$3vvk876hypkbb as HashSet_init_$Create$,
  singleOrNullrknfaxokm1sl as singleOrNull,
  Collection1k04j3hzsbod0 as Collection,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  KSerializerzf77vz1967fq as KSerializer,
  BinaryFormat3f3aelhmz0ro1 as BinaryFormat,
  StringFormat2r2ka8mzcb3mi as StringFormat,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  serializerOrNull31x2b6nu6gruj as serializerOrNull,
  serializer1rka18p0rjk4x as serializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
  serializer1x79l67jvwntn as serializer_0,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  ByteArrayContent9zol65b22hp0 as ByteArrayContent,
  withCharsetIfNeeded3sz33ys0x9vfx as withCharsetIfNeeded,
  TextContent1rb6ftlpvl1d2 as TextContent,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
} from './ktor-ktor-http.mjs';
import {
  FlowCollector26clgpmzihvke as FlowCollector,
  asFlow3ngsnn5xpz8pw as asFlow,
  firstOrNull3jjcu7fygcopr as firstOrNull_0,
} from './kotlinx-coroutines-core.mjs';
import {
  readRemaining1x8kk1vq7p6gm as readRemaining,
  discard3ugntd47xyll6 as discard,
  readText27783kyxjxi1g as readText,
} from './ktor-ktor-io.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from './kotlinx-io-kotlinx-io-core.mjs';
import { JsonConvertExceptiongnc5x6xwaf77 as JsonConvertException } from './ktor-ktor-serialization.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForLambda(KotlinxSerializationConverter$serialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
initMetadataForLambda(KotlinxSerializationConverter$deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($collectCOROUTINE$_0, CoroutineImpl);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(KotlinxSerializationConverter$serialize$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForLambda(KotlinxSerializationConverter$serialize$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(KotlinxSerializationConverter$deserialize$$inlined$map$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForLambda(KotlinxSerializationConverter$deserialize$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($serializeCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($deserializeCOROUTINE$, CoroutineImpl);
initMetadataForClass(KotlinxSerializationConverter, 'KotlinxSerializationConverter', VOID, VOID, VOID, [4, 3]);
//endregion
function extensions(format) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_providers();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp0_safe_receiver = element.u63(format);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.j(tmp0_safe_receiver);
    }
  }
  return destination;
}
function serialization(_this__u8e3s4, contentType, format) {
  _this__u8e3s4.j4g(contentType, new KotlinxSerializationConverter(format));
}
function KotlinxSerializationConverter$serialize$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
  this.d64_1 = $$this$unsafeFlow;
  this.e64_1 = $contentType;
  this.f64_1 = $charset;
  this.g64_1 = $typeInfo;
  this.h64_1 = $value;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).z4g = function (value, $completion) {
  var tmp = this.a4h(value, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).x8 = function (p1, $completion) {
  return this.z4g((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp0 = this.d64_1;
          var tmp2 = this.i64_1;
          this.j64_1 = tmp0;
          this.d8_1 = 1;
          suspendResult = tmp2.t63(this.e64_1, this.f64_1, this.g64_1, this.h64_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          this.d8_1 = 2;
          suspendResult = this.j64_1.n2e(ARGUMENT, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(KotlinxSerializationConverter$serialize$o$collect$slambda).a4h = function (value, completion) {
  var i = new KotlinxSerializationConverter$serialize$o$collect$slambda(this.d64_1, this.e64_1, this.f64_1, this.g64_1, this.h64_1, completion);
  i.i64_1 = value;
  return i;
};
function KotlinxSerializationConverter$serialize$o$collect$slambda_0($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
  var i = new KotlinxSerializationConverter$serialize$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation);
  var l = function (value, $completion) {
    return i.z4g(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s64_1 = _this__u8e3s4;
  this.t64_1 = collector;
}
protoOf($collectCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var $this$unsafeFlow = this.t64_1;
          this.d8_1 = 1;
          var tmp_0 = KotlinxSerializationConverter$serialize$o$collect$slambda_0($this$unsafeFlow, this.s64_1.v64_1, this.s64_1.w64_1, this.s64_1.x64_1, this.s64_1.y64_1, null);
          suspendResult = this.s64_1.u64_1.p2e(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
  this.h65_1 = $$this$unsafeFlow;
  this.i65_1 = $charset;
  this.j65_1 = $typeInfo;
  this.k65_1 = $content;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).z4g = function (value, $completion) {
  var tmp = this.a4h(value, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).x8 = function (p1, $completion) {
  return this.z4g((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp0 = this.h65_1;
          var tmp2 = this.l65_1;
          this.m65_1 = tmp0;
          this.d8_1 = 1;
          suspendResult = tmp2.b4h(this.i65_1, this.j65_1, this.k65_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          this.d8_1 = 2;
          suspendResult = this.m65_1.n2e(ARGUMENT, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).a4h = function (value, completion) {
  var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda(this.h65_1, this.i65_1, this.j65_1, this.k65_1, completion);
  i.l65_1 = value;
  return i;
};
function KotlinxSerializationConverter$deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
  var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation);
  var l = function (value, $completion) {
    return i.z4g(value, $completion);
  };
  l.$arity = 1;
  return l;
}
function $collectCOROUTINE$_0(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.v65_1 = _this__u8e3s4;
  this.w65_1 = collector;
}
protoOf($collectCOROUTINE$_0).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var $this$unsafeFlow = this.w65_1;
          this.d8_1 = 1;
          var tmp_0 = KotlinxSerializationConverter$deserialize$o$collect$slambda_0($this$unsafeFlow, this.v65_1.y65_1, this.v65_1.z65_1, this.v65_1.a66_1, null);
          suspendResult = this.v65_1.x65_1.p2e(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_0), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function serializeContent($this, serializer, format, value, contentType, charset) {
  var tmp;
  if (isInterface(format, StringFormat)) {
    var content = format.iq(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
    tmp = new TextContent(content, withCharsetIfNeeded(contentType, charset));
  } else {
    if (isInterface(format, BinaryFormat)) {
      var content_0 = format.kq(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
      tmp = new ByteArrayContent(content_0, contentType);
    } else {
      var message = 'Unsupported format ' + toString(format);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  return tmp;
}
function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
  this.b66_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).n2e = function (value, $completion) {
  return this.b66_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).r2 = function () {
  return this.b66_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.r2(), other.r2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
  return hashCode(this.r2());
};
function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
  this.c66_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).n2e = function (value, $completion) {
  return this.c66_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).r2 = function () {
  return this.c66_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.r2(), other.r2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
  return hashCode(this.r2());
};
function KotlinxSerializationConverter$serialize$$inlined$map$1($this, $contentType, $charset, $typeInfo, $value) {
  this.u64_1 = $this;
  this.v64_1 = $contentType;
  this.w64_1 = $charset;
  this.x64_1 = $typeInfo;
  this.y64_1 = $value;
}
protoOf(KotlinxSerializationConverter$serialize$$inlined$map$1).o2e = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$(this, collector, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter$serialize$$inlined$map$1).p2e = function (collector, $completion) {
  return this.o2e(collector, $completion);
};
function KotlinxSerializationConverter$serialize$slambda(resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KotlinxSerializationConverter$serialize$slambda).m66 = function (it, $completion) {
  var tmp = this.n66(it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter$serialize$slambda).x8 = function (p1, $completion) {
  return this.m66((p1 == null ? true : p1 instanceof OutgoingContent) ? p1 : THROW_CCE(), $completion);
};
protoOf(KotlinxSerializationConverter$serialize$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        return !(this.l66_1 == null);
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(KotlinxSerializationConverter$serialize$slambda).n66 = function (it, completion) {
  var i = new KotlinxSerializationConverter$serialize$slambda(completion);
  i.l66_1 = it;
  return i;
};
function KotlinxSerializationConverter$serialize$slambda_0(resultContinuation) {
  var i = new KotlinxSerializationConverter$serialize$slambda(resultContinuation);
  var l = function (it, $completion) {
    return i.m66(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function KotlinxSerializationConverter$deserialize$$inlined$map$1($this, $charset, $typeInfo, $content) {
  this.x65_1 = $this;
  this.y65_1 = $charset;
  this.z65_1 = $typeInfo;
  this.a66_1 = $content;
}
protoOf(KotlinxSerializationConverter$deserialize$$inlined$map$1).o2e = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$_0(this, collector, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter$deserialize$$inlined$map$1).p2e = function (collector, $completion) {
  return this.o2e(collector, $completion);
};
function KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation) {
  this.w66_1 = $content;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KotlinxSerializationConverter$deserialize$slambda).a4i = function (it, $completion) {
  var tmp = this.a4h(it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter$deserialize$slambda).x8 = function (p1, $completion) {
  return this.a4i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
};
protoOf(KotlinxSerializationConverter$deserialize$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      if (tmp === 0) {
        this.e8_1 = 1;
        return !(this.x66_1 == null) || this.w66_1.r2l();
      } else if (tmp === 1) {
        throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(KotlinxSerializationConverter$deserialize$slambda).a4h = function (it, completion) {
  var i = new KotlinxSerializationConverter$deserialize$slambda(this.w66_1, completion);
  i.x66_1 = it;
  return i;
};
function KotlinxSerializationConverter$deserialize$slambda_0($content, resultContinuation) {
  var i = new KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation);
  var l = function (it, $completion) {
    return i.a4i(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function $serializeCOROUTINE$(_this__u8e3s4, contentType, charset, typeInfo, value, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g67_1 = _this__u8e3s4;
  this.h67_1 = contentType;
  this.i67_1 = charset;
  this.j67_1 = typeInfo;
  this.k67_1 = value;
}
protoOf($serializeCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          var this_0 = asFlow(this.g67_1.m67_1);
          var tmp_0 = new KotlinxSerializationConverter$serialize$$inlined$map$1(this_0, this.h67_1, this.i67_1, this.j67_1, this.k67_1);
          suspendResult = firstOrNull_0(tmp_0, KotlinxSerializationConverter$serialize$slambda_0(null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var fromExtension = suspendResult;
          if (!(fromExtension == null))
            return fromExtension;
          var tmp_1;
          try {
            tmp_1 = serializerForTypeInfo(this.g67_1.l67_1.ht(), this.j67_1);
          } catch ($p) {
            var tmp_2;
            if ($p instanceof SerializationException) {
              var cause = $p;
              tmp_2 = guessSerializer(this.k67_1, this.g67_1.l67_1.ht());
            } else {
              throw $p;
            }
            tmp_1 = tmp_2;
          }

          var serializer = tmp_1;
          return serializeContent(this.g67_1, serializer, this.g67_1.l67_1, this.k67_1, this.h67_1, this.i67_1);
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $deserializeCOROUTINE$(_this__u8e3s4, charset, typeInfo, content, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.v67_1 = _this__u8e3s4;
  this.w67_1 = charset;
  this.x67_1 = typeInfo;
  this.y67_1 = content;
}
protoOf($deserializeCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.d8_1 = 1;
          var this_0 = asFlow(this.v67_1.m67_1);
          var tmp_0 = new KotlinxSerializationConverter$deserialize$$inlined$map$1(this_0, this.w67_1, this.x67_1, this.y67_1);
          suspendResult = firstOrNull_0(tmp_0, KotlinxSerializationConverter$deserialize$slambda_0(this.y67_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var fromExtension = suspendResult;
          var tmp_1;
          if (!this.v67_1.m67_1.q()) {
            tmp_1 = !(fromExtension == null) || this.y67_1.r2l();
          } else {
            tmp_1 = false;
          }

          if (tmp_1)
            return fromExtension;
          this.z67_1 = serializerForTypeInfo(this.v67_1.l67_1.ht(), this.x67_1);
          this.d8_1 = 2;
          suspendResult = readRemaining(this.y67_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var contentPacket = suspendResult;
          this.e8_1 = 3;
          var tmp0_subject = this.v67_1.l67_1;
          var tmp_2;
          if (isInterface(tmp0_subject, StringFormat)) {
            tmp_2 = this.v67_1.l67_1.jq(this.z67_1, readText(contentPacket, this.w67_1));
          } else {
            if (isInterface(tmp0_subject, BinaryFormat)) {
              tmp_2 = this.v67_1.l67_1.lq(this.z67_1, readByteArray(contentPacket));
            } else {
              discard(contentPacket);
              var message = 'Unsupported format ' + toString(this.v67_1.l67_1);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }

          return tmp_2;
        case 3:
          this.e8_1 = 4;
          var tmp_3 = this.g8_1;
          if (tmp_3 instanceof Error) {
            var cause = this.g8_1;
            throw new JsonConvertException('Illegal input: ' + cause.message, cause);
          } else {
            throw this.g8_1;
          }

        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function KotlinxSerializationConverter(format) {
  this.l67_1 = format;
  this.m67_1 = extensions(this.l67_1);
  var tmp;
  var tmp_0 = this.l67_1;
  if (isInterface(tmp_0, BinaryFormat)) {
    tmp = true;
  } else {
    var tmp_1 = this.l67_1;
    tmp = isInterface(tmp_1, StringFormat);
  }
  // Inline function 'kotlin.require' call
  if (!tmp) {
    var message = 'Only binary and string formats are supported, ' + toString(this.l67_1) + ' is not supported.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(KotlinxSerializationConverter).a68 = function (contentType, charset, typeInfo, value, $completion) {
  var tmp = new $serializeCOROUTINE$(this, contentType, charset, typeInfo, value, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(KotlinxSerializationConverter).t63 = function (contentType, charset, typeInfo, value, $completion) {
  return this.a68(contentType, charset, typeInfo, value, $completion);
};
protoOf(KotlinxSerializationConverter).b4h = function (charset, typeInfo, content, $completion) {
  var tmp = new $deserializeCOROUTINE$(this, charset, typeInfo, content, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
function serializerForTypeInfo(_this__u8e3s4, typeInfo) {
  var module_0 = _this__u8e3s4;
  var tmp0_safe_receiver = typeInfo.s31_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    if (tmp0_safe_receiver.ta().q()) {
      tmp_0 = null;
    } else {
      tmp_0 = serializerOrNull(module_0, tmp0_safe_receiver);
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = module_0.oq(typeInfo.r31_1);
    tmp_1 = tmp2_safe_receiver == null ? null : maybeNullable(tmp2_safe_receiver, typeInfo);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_1;
  return tmp3_elvis_lhs == null ? maybeNullable(serializer(typeInfo.r31_1), typeInfo) : tmp3_elvis_lhs;
}
function guessSerializer(value, module_0) {
  var tmp;
  if (value == null) {
    tmp = get_nullable(serializer_0(StringCompanionObject_instance));
  } else {
    if (isInterface(value, KtList)) {
      tmp = ListSerializer(elementSerializer(value, module_0));
    } else {
      if (isArray(value)) {
        var tmp1_safe_receiver = firstOrNull(value);
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = guessSerializer(tmp1_safe_receiver, module_0);
        }
        var tmp2_elvis_lhs = tmp_0;
        tmp = tmp2_elvis_lhs == null ? ListSerializer(serializer_0(StringCompanionObject_instance)) : tmp2_elvis_lhs;
      } else {
        if (isInterface(value, KtSet)) {
          tmp = SetSerializer(elementSerializer(value, module_0));
        } else {
          if (isInterface(value, KtMap)) {
            var keySerializer = elementSerializer(value.d2(), module_0);
            var valueSerializer = elementSerializer(value.e2(), module_0);
            tmp = MapSerializer(keySerializer, valueSerializer);
          } else {
            var tmp3_elvis_lhs = module_0.oq(getKClassFromExpression(value));
            tmp = tmp3_elvis_lhs == null ? serializer(getKClassFromExpression(value)) : tmp3_elvis_lhs;
          }
        }
      }
    }
  }
  var tmp_1 = tmp;
  return isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
}
function maybeNullable(_this__u8e3s4, typeInfo) {
  var tmp;
  var tmp0_safe_receiver = typeInfo.s31_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ua()) === true) {
    tmp = get_nullable(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function elementSerializer(_this__u8e3s4, module_0) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = filterNotNull(_this__u8e3s4);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = guessSerializer(item, module_0);
    destination.j(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.distinctBy' call
  var set = HashSet_init_$Create$();
  var list = ArrayList_init_$Create$();
  var _iterator__ex2g4s_0 = destination.l();
  while (_iterator__ex2g4s_0.m()) {
    var e = _iterator__ex2g4s_0.n();
    var key = e.fp().gq();
    if (set.j(key)) {
      list.j(e);
    }
  }
  var serializers = list;
  if (serializers.o() > 1) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(serializers, 10));
    var _iterator__ex2g4s_1 = serializers.l();
    while (_iterator__ex2g4s_1.m()) {
      var item_0 = _iterator__ex2g4s_1.n();
      var tmp$ret$5 = item_0.fp().gq();
      destination_0.j(tmp$ret$5);
    }
    // Inline function 'kotlin.error' call
    var message = 'Serializing collections of different element types is not yet supported. ' + ('Selected serializers: ' + toString(destination_0));
    throw IllegalStateException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = singleOrNull(serializers);
  var selected = tmp0_elvis_lhs == null ? serializer_0(StringCompanionObject_instance) : tmp0_elvis_lhs;
  if (selected.fp().sq()) {
    return selected;
  }
  if (!isInterface(selected, KSerializer))
    THROW_CCE();
  var tmp$ret$8;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.q();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$8 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_2 = _this__u8e3s4.l();
    while (_iterator__ex2g4s_2.m()) {
      var element = _iterator__ex2g4s_2.n();
      if (element == null) {
        tmp$ret$8 = true;
        break $l$block_0;
      }
    }
    tmp$ret$8 = false;
  }
  if (tmp$ret$8) {
    return get_nullable(selected);
  }
  return selected;
}
function get_providers() {
  return emptyList();
}
//region block: exports
export {
  serialization as serialization1fpeds7cruos4,
};
//endregion

//# sourceMappingURL=ktor-ktor-serialization-kotlinx.mjs.map
